<template>
  <th :width="width" class="sf-pointer" @click="headerClick">
    <slot
      name="header"
      :header="header"
      :header-label="headerLabel"
      :header-index="headerIndex"
      :sort-by="sortBy"
      :sort-direction="sortDirection"
    >
      <SfTableHeaderCell
        :header-id="headerId"
        :header-index="headerIndex"
        :max-header-cell-width="maxHeaderCellWidth"
        :sort-direction="sortDirection"
        :sort-by="sortBy"
        :sortable="!nonSortableHeaders.includes(header)"
      >
        {{ headerLabel }}
      </SfTableHeaderCell>
    </slot>
  </th>
</template>
<script>
import SfTableHeaderCell from './sf-table-header-cell.vue'

export default {
  name: 'SfTableHeader',
  components: {
    SfTableHeaderCell,
  },
  props: {
    header: {
      type: [String, Object],
      required: true,
    },
    headerIndex: {
      type: Number,
      required: true,
    },
    maxHeaderCellWidth: {
      type: Number,
      default: null,
    },
    nonSortableHeaders: {
      type: Array,
      default: () => [],
    },
    sortDirection: {
      type: String,
      required: true,
    },
    sortBy: {
      type: String,
      required: true,
    },
  },
  emits: ['headerClick'],
  computed: {
    headerLabel() {
      return this.header.label || this.header.id || this.header
    },
    headerId() {
      return this.header.id || this.header
    },
    width() {
      return this.header.width || ''
    },
  },
  methods: {
    headerClick() {
      this.$emit('headerClick', this.headerId)
    },
  },
}
</script>
